import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

export interface RefreshSessionResponse {
    sessionId: string;
    expiresIn: number; // seconds
}

@Injectable({
    providedIn: 'root'
})
export class AuthService {
    private readonly _apiUrl: string = environment.apiUrl;
    private readonly _httpClient: HttpClient = inject(HttpClient);

    checkValidSession(): Observable<boolean> {
        return this._httpClient.get<boolean>(`${ this._apiUrl }api/session/valid`, {});
    }

    refreshSession(): Observable<RefreshSessionResponse> {
        return this._httpClient.post<RefreshSessionResponse>(`${ this._apiUrl }api/session/refresh`, {});
    }
}
